"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const EmailTemplateVersionDetail_1 = require("../EmailTemplateVersionDetail");
const react_2 = require("@osmosys/react");
exports.Production = ({ template }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, template.productionVersion ? (react_1.default.createElement(EmailTemplateVersionDetail_1.EmailTemplateVersionDetail, { useCard: true, data: template.productionVersion })) : (react_1.default.createElement(react_2.OsmosysSmallContainer, { maxWidth: 660 },
        react_1.default.createElement("div", { className: "text-center" },
            react_1.default.createElement("h3", null,
                "There is no ",
                react_1.default.createElement("strong", null, "production"),
                " template deployed"),
            react_1.default.createElement("p", { className: "lead" },
                "To deploy to production, first ensure you have deployed to",
                ' ',
                react_1.default.createElement(react_router_dom_1.Link, { to: `/templates/${template.id}/staging` }, "staging"),
                "."))))));
};
//# sourceMappingURL=Production.js.map